import InteractiveCatalogPageItem from '../InteractiveCatalogPageItem';

export default class ImageItem extends InteractiveCatalogPageItem {

    constructor() {
        super();
        this.path = '';
    }

    clone() {
        let target = new ImageItem();
        $.extend(target, this);
        return target;
    }

}
